module.exports = __webpack_public_path__ + "static/media/docs (1).b81fd925.webp";